module.exports = __webpack_public_path__ + "assets/img/bannerstand-selection-banner.30c27e36.png";